module.exports = __webpack_public_path__ + "img/icon-map-implantation-12.2df9d207.svg";